var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.001,
    height: 16.001,
    fill: "currentColor",
    className: "bi bi-pencil",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.146.147a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-10 10a.5.5 0 01-.168.11l-5 2a.5.5 0 01-.65-.65l2-5a.5.5 0 01.11-.168zm-.94 2.354L13.5 4.794 14.793 3.5 12.5 1.208zm1.587 3L10.5 3.208 4 9.708V10h.5a.5.5 0 01.5.5v.5h.5a.5.5 0 01.5.5v.5h.293zm-9.761 5.175l-.106.106-1.528 3.82 3.82-1.527.107-.106A.5.5 0 015 12.5V12h-.5a.5.5 0 01-.5-.5V11h-.5a.5.5 0 01-.468-.325",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1);
export default __webpack_public_path__ + "static/media/path1.c7d3731ffa0030beb16c6a0624508de5.svg";
export { ForwardRef as ReactComponent };